module.exports = "/_next/static/images/1a5fbf9d5c7b18b3f9db455146ba6354-piecito-mobile.png";